// UserComponent.js
import React, { useEffect, useState } from 'react';
import logo from '../images/kalingarayanrunners_logo.svg';
import { useRecoilState, useRecoilValue } from 'recoil';
import ContactPopup from './Popup';
import { Link } from 'react-router-dom';
import { ActiveEvents, pageDetails } from '../Recoil/ActiveEvents';
import { FaPhoneAlt } from 'react-icons/fa';

function Header() {
  const [isOpen, setIsOpen] = useState(null);
  const [currentIndex,setCurrentIndex] = useState(0);
  const [activeEvents, setActiveEvents] = useRecoilState(ActiveEvents);
  const [currIndex, setCurrIndex] = useRecoilState(pageDetails);

  useEffect(() => {
    // setCurrentIndex(currIndex.currentIndex)
    let eventURI = process.env.REACT_APP_API_URL +"/Events/GetUpcomingEvents";
    fetch(eventURI , {method: "GET"})
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        let events = !!data.EventsType && !data.EventsType[0].ErrorMessage ? data.EventsType : []
        setActiveEvents(events);
        // setLoading(false);
      })
      .catch(error => {
        // setError(error.message);
        // setLoading(false);
      });
  }, []);

  const updateBoollen = (value) => {
    setIsOpen(value);
  }

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % activeEvents.length);
    setTimeout(() => {
      setCurrIndex({...currIndex, currentIndex:currentIndex})
    }, 100);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + activeEvents.length) % activeEvents.length);
    setTimeout(() => {
      setCurrIndex({...currIndex, currentIndex:currentIndex})
    }, 100);
  };
  return (
    <div>
          <ContactPopup popup={isOpen} updateValue={(value)=>updateBoollen(value)}/>
          {/* <div className="relative w-full h-screen overflow-hidden "> */}
          <div className='relative max-w-full overflow-hidden mt-20 md:m-0'>
          <div className="flex transition-transform duration-500 ease-in-out relative w-full sm:h-[80vh] md:h-[100vh] relative" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
              {activeEvents.map((item, index) => (
                <div className="flex-shrink-0 w-full h-full" key={index}>
                  <img src={item.ImgUrl} alt={item.EventName} className="h-full w-full"  />
                </div>
              ))} 
          </div>
          <button
            className="absolute top-1/2 left-0 transform -translate-y-1/2 p-4 bg-black bg-opacity-25 text-white"
            onClick={prevSlide}
          >❮</button>
          <button
            className="absolute top-1/2 right-0 transform -translate-y-1/2 p-4 bg-black bg-opacity-25 text-white"
            onClick={nextSlide}
          >❯</button>
        </div>
        <div className="absolute top-0 left-0 w-[100%] bg-opacity-50 flex items-center justify-center text-white z-10 h-[80px]">
          <header className="relative p-4 fixed top-0 left-0 w-full z-[3]">
          {/* <header className="relative p-4 fixed top-0 left-0 z-[3] w-full bg-orange-500 bg-opacity-20"> */}
              <div className="container mx-auto flex justify-between items-center">
                  <div className="text-2xl font-semibold">
                    <Link to="/"> <img 
                          src= {logo} 
                          alt="Logo" 
                          className="sm:max-w-[14rem] max-w-[12rem] " 
                      /></Link>
                  </div>
                  <nav>
                      <ul className="flex">
                          <li><Link to="/registration" className="text-sm text-white">
                            {/* <button className='hidden sm:block lg:hidden bg-red-600 w-14 h-10 rounded-l-lg'><FaWpforms className='ml-5' /></button> */}
                            <button className='bg-red-600 w-28 h-10 rounded-l-lg'>Register</button>
                          </Link></li>
                          {/* <li><Link to="/events" className="text-sm text-white"><button className='bg-blue-600 w-28 h-10 '>Events</button></Link></li> */}
                          <li>
                            <button className='block xs:block md:hidden lg:hidden text-sm text-white bg-emerald-600 w-14 h-10 rounded-r-lg' onClick={()=>updateBoollen(true)}><FaPhoneAlt className='ml-5' /></button>
                            <button className='hidden md:block lg:block text-sm text-white bg-emerald-600 w-28 h-10 rounded-r-lg' onClick={()=>updateBoollen(true)}>Contact Us</button>
                          </li> 
                      </ul>
                  </nav>
              </div>
          </header>
        </div>
    </div>
  );
}

export default Header;
